import { useTranslation } from 'react-i18next'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { ensureExists } from '~/utils'

import { pathKey } from '../utils'

export const useStrategyMemoId = () => {
  const { t } = useTranslation()
  const { strategyMemoId } = usePathParams(pathKey)

  return ensureExists(strategyMemoId, t('assertion_failed'))
}
